<template>
  <div class="loading default-bg">
    <top-navigation :show-home="false" :show-avatar="false" :show-back="false" :show-full-screen="false">
      <div slot="middle" class="hash">
        <h2>#SAVETOGETHER</h2>
      </div>
    </top-navigation>
    <div class="container-fluid content-wrapper middle">
      <div class="row">
        <div class="col-12 ">
          <div class="mx-auto content" v-if="currentFact">
            <h1>DID YOU KNOW?</h1>
            <p v-html="currentFact.post_content"></p>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid fixed-bottom">
      <div class="row">
        <div class="col-4">
        </div>
        <div class="col-4 loading-text-wrapper">
          <div class="loading-text">
            <h1>LOADING{{dots}}</h1>
          </div>
        </div>
        <div class="col-4 logo">
          <!-- <img src="../assets/img/logo.png"> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TopNavigation from '../components/TopNavigation'

export default {
  name: 'Loading',
  components: { TopNavigation },
  data () {
    return {
      dots: ''
    }
  },
  mounted () {
    let count = 0
    setInterval(() => {
      if (count === 3) {
        this.dots = ''
        count = 0
      } else {
        this.dots += '.'
        count++
      }
    }, 200)
    setTimeout(() => {
      this.$router.push('/selection')
    }, 5000)
  },
  computed: {
    ...mapGetters(['facts']),
    currentFact () {
      if (this.facts.length) {
        return this.facts[Math.floor(Math.random() * (this.facts.length - 1))]
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>
  .loading .hash {
    padding-top: 20px;
  }

  .hash h2 {
    font-size: 3vh;
  }

  .content {
    width: 80%;
    text-transform: uppercase;
    border-left: 1.5vw solid #ffbf00;
    padding-left: 4vw;
  }

  .content-wrapper {
    display: flex;
    height: 80vh;
  }

  .content h1 {
    font-family: "Geograph-Bold";
    color: #feca33;
    padding-bottom: 4vh;
    font-size: 6vh;
    text-shadow: 0px 6px 6px rgba(0, 0, 0, 0.6);
  }

  .content p {
    font-size: 5vh;
    color: #ffffff;
    font-family: "Geograph-Bold";
    text-shadow: 0px 6px 6px rgba(0, 0, 0, 0.6);
  }

  .loading-text-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .loading-text {
    padding-top: 5vh;
    margin-left: auto;
    margin-right: auto;
    color: #ffffff;
    width: 10vw;
  }

  .loading-text h1 {
    font-size: 4vh;
    font-family: "Geograph-Bold";
  }
</style>
